<style scoped lang="scss">
.small-card {
  .box-card {
    margin-bottom: 20px;
    ::v-deep.el-card__header {
      padding: 16px 20px 0 24px;
      border-bottom: 1px solid #f0f0ff;
      div {
        .title {
          font-size: 14px;
          color: #262626;
          font-weight: 600;
        }
        .btns {
          float: right;
        }
      }
    }
  }
}
.datas-container {
  .goods-box {
    overflow: hidden;
    zoom: 1;
    //  margin-right:-12px;
    .goods-list {
      .item {
        border: 1px solid rgba(0, 0, 0, 0.05);
        padding: 8px;
        margin-bottom: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        .num {
          position: absolute;
          left: 0;
          top: 0;
          width: 16px;
          height: 16px;
          background: rgba(0, 0, 0, 0.25);
          text-align: center;
          line-height: 16px;
          color: #fff;
          font-size: 12px;
        }
        &-img {
          width: 52px;
          height: 52px;
        }
        &-info {
          flex: 1;
          padding-left: 20px;
          .title {
            font-size: 14px;
            color: #262626;
            height: 28px;
            line-height: 28px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .sku {
            font-size: 12px;
            color: #262626;
            height: 22px;
            line-height: 22px;
          }
        }
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}
</style>
<template>
  <div>
    <SpCardContent
      :title="title"
      class="smallCard"
      :btns="disabled ? null : textArray"
      @btnsOption="managerOperate"
    >
      <div class="meter-text">
        已选择 {{ meters.selectGoodsData.length }} 件商品，最多选择9件，拖动以排序
      </div>
      <div class="datas-container">
        <div
          v-if="meters"
          class="goods-box"
        >
          <ul
            v-if="meters.selectGoodsData"
            class="goods-list"
          >
            <draggable
              v-model="meters.selectGoodsData"
              @start="onStart"
              @end="onEnd"
            >
              <li
                v-for="(item, index) in meters.selectGoodsData"
                :key="item.item_id"
                class="item"
              >
                <img
                  :src="item.pic"
                  class="item-img"
                >
                <div class="item-info">
                  <h4 class="title">
                    {{ item.item_name }}
                  </h4>
                  <p
                    v-if="item.sku != ''"
                    class="sku"
                  >
                    {{ item.sku }}
                  </p>
                </div>
                <span class="num">{{ index + 1 }}</span>
              </li>
            </draggable>
          </ul>
        </div>
      </div>
    </SpCardContent>
    <!-- 选择商品 -->
    <GoodsSelect
      :goods-visible="meters.goodsVisible"
      :select-data="meters.selectGoodsData"
      :title="goodsTitle"
      @closeGoodsDialog="closeGoodsDialog"
      @chooseGoods="chooseGoods"
    />
  </div>
</template>

<script>
import GoodsSelect from '@/components/goodsSelect'
// 第三方组件
import draggable from 'vuedraggable'

export default {
  components: {
    GoodsSelect,
    draggable
  },
  props: {
    meters: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      text: '商品',
      title: '商品管理',
      textArray: [
        { key: 'clear', name: '清空', type: 'text' },
        { key: 'edit', name: '编辑商品', type: 'primary' }
      ],
      goodsTitle: '选择商品'
    }
  },
  watch: {
    meters (nVal, oVal) {
      console.log('nVal------->', nVal)
    }
  },
  mounted () {
    console.log('goods------>', this.meters)
  },
  created () {
    console.log(this.$router.history.current.path)
    if ('/drainage/formActivity/new'.indexOf(this.$router.history.current.path !== -1)) {
      this.text = '奖品'
      this.title = '奖品管理'
      this.textArray = [
        { key: 'clear', name: '清空', type: 'text' },
        { key: 'edit', name: '编辑奖品', type: 'primary' }
      ]
      this.goodsTitle = '选择奖品'
    } else {
      this.text = '商品'
      this.title = '商品管理'
      this.textArray = [
        { key: 'clear', name: '清空', type: 'text' },
        { key: 'edit', name: '编辑商品', type: 'primary' }
      ]
      this.goodsTitle = '选择商品'
    }
  },
  methods: {
    managerOperate (key) {
      if (key === 'clear') {
        this.meters.selectGoodsData = []
      }
      if (key === 'edit') {
        console.log('this.meters', this.meters)
        this.meters.goodsVisible = true
      }
    },
    // 关闭商品对话框
    closeGoodsDialog () {
      this.meters.goodsVisible = false
    },

    chooseGoods (selectdata, ids) {
      console.log('selectdata---->', selectdata)
      let index = this.currentIndex
      if (this.meters.time_type !== 3) {
        let errormsg = this.meters.time_type === 1 ? '已结束' : '正在进行中'
        this.$message.error('目标' + errormsg + '不可编辑')
        return
      }
      if (selectdata.length > 9) {
        this.$message.error('最多选择9个商品')
      } else if (0 < selectdata.length <= 9) {
        this.meters.selectGoodsData = selectdata
        this.meters.item_id = ids
        this.meters.goodsVisible = false
      } else {
        this.meters.selectGoodsData = []
        this.meters.item_id = ''
        this.meters.goodsVisible = false
      }
    },

    // 删除图片
    removePicsImg: function (i) {
      this.meters.pics.splice(i, 1)
    },

    // 拖拽绑定事件
    onStart (evt) {
      console.log(evt)
    },
    onEnd (evt) {
      console.log(evt)
    }
  }
}
</script>
